import React from 'react';
import { MdDone, MdReportProblem } from 'react-icons/lib/md';

const ONE_DAY = 86400 * 1000; // number of milliseconds

export const NBSP = '\u00A0';

export function formatDate (string) {
    if (!string) return NBSP;

    const year = string.slice(0, 4);
    const month = string.slice(5, 7);
    const date = string.slice(8, 10);

    return `${month}/${date}/${year}`;
}

export function camelToTitle (string) {
    switch(string) {
            case 38: return 'Award';
            case 39: return 'Progress Report';
            case 40: return 'Substantial Completion';
            default:
                break;
    }

    if (typeof(string) === 'number') return string;

    const spaced = string.replace(/([A-Z])/g, ' $1');
    return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

export function milestoneToTitle (milestone, divisionName) {
    if (divisionName === 'Infrastructure' && milestone === 'schematicDesignCompletion') {
        milestone = 'preliminaryDesignCompletion';
    }
    return camelToTitle(milestone);
}

export function statusFromDates (start, end) {
    if (!start || !end) return NBSP;

    const startDate = new Date(start);
    const endDate = new Date(end);
    const diffMilliSeconds = endDate.getTime() - startDate.getTime()
    const diffDays = Math.round(diffMilliSeconds / ONE_DAY)

    return (diffDays < 30)
    ? <span> <MdDone size={22} color="#008000"/> </span>
    : <span> <MdReportProblem size={22} color="#F4633D"/> 
        <strong>more than 30 days behind schedule</strong>
      </span>
}

const stopPropagation = (e) => e.stopPropagation();

export function formatPhoneNumber (string) {
    const numbers = ('' + string).replace(/\D/g, '');
    const matches = numbers.match(/^(\d{3})(\d{3})(\d{4})$/);
    const formatted = (!matches) ? string : `${matches[1]}-${matches[2]}-${matches[3]}`;
    return <a href={'tel:' + formatted} onClick={stopPropagation}>{formatted}</a>;
}

export function formatPhoneInput (string) {
    if (!string) return '';
    if (string.length <= 3) {
    // pass
    } else if (string.length <= 6) {
        string = string.replace(/^(\d{3})(\d+)/, '$1-$2');
    } else {
        string = string.replace(/^(\d{3})(\d{3})(\d+)/, '$1-$2-$3');
    }
    return string;
}

export function formatEmail (email) {
    return <a href={'mailto:' + email} onClick={stopPropagation}>{email}</a>
}

export function getFullName (person) {
    return `${person.firstName} ${person.lastName}`;
}

export function getFileExtension (filename) {
    const parts = filename.trim().split('.')
    if (parts.length < 2) return null;
    return parts[parts.length - 1].toUpperCase();
}

export function calcPageCount(numDocs, pageSize) {
    const rem = numDocs % pageSize;
    const divCount = Math.floor(numDocs / pageSize);
    const pageCount = (rem===0) ? divCount : divCount + 1;
    return pageCount;
}

export function getProjectType(projectTypes, projectTypeId) {
    if (projectTypes === undefined)
        return 0;
    
    var found = projectTypes.find(function(pt) {
        return pt.id === projectTypeId;
    });
  
    if (!found) return 0;
  
    return found.projectType;
}

export function checkMulti(projectTypes, projectTypeId) {
    if (projectTypes === undefined || projectTypeId  === undefined)
        return 0;
    
    var found = projectTypes.find(function(pt) {
        return pt.id === projectTypeId;
    });
  
    if ( found ) {
        return found.isMultiSelect;
    }

    return 0;
}

export const queueTypes = {
    1: 'PM',
    2: 'AE'
  };